import { useState } from "react";
import ReactPaginate from "react-paginate";

import ProductItem from "./ProductItem";

export default function Index({
  data,
  setProductUpdater,
  deactivateProduct,
  productListTotal,
  productListFunc,
}) {
  const [pagination, setPagination] = useState(1);
  return (
    <div>
      {data?.map((value) => (
        <ProductItem
          array={value}
          setProductUpdater={setProductUpdater}
          deactivateProduct={deactivateProduct}
        />
      ))}
      <div className=" d-flex justify-content-center mt-3">
        <ReactPaginate
          // forcePage={pagination}
          previousLabel={"قبلی"}
          nextLabel={"بعدی"}
          breakLabel={"..."}
          breakClassName={"break-me"}
          pageCount={Math.ceil(productListTotal / 10)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={2}
          onPageChange={(e) => {
            setPagination(e.selected);
            productListFunc({}, e.selected + 1);
          }}
          containerClassName="pagination mx-auto mb-3"
          activeLinkClassName="text-white"
          activeClassName="bg-info style-activeClass"
          pageClassName="style-pageClass mx-2 border border-1"
          pageLinkClassName="page-link style-page-link"
          nextClassName="border btn mx-1 px-4 py-1 "
          previousClassName="border btn mx-1 px-4 py-1  "
          nextLinkClassName="style-nextLink "
          previousLinkClassName="style-previousLink "
        />
      </div>
    </div>
  );
}
